import { Button } from "react-bootstrap";

export const supervisorTicketAnalyticsColumns = [
  {
    dataField: "supervisor_name",
    text: "Supervisor",
    formatter: (_, row) => (
      <span className="fw-semibold">{row.supervisor_name}</span>
    ),
  },
  {
    dataField: "avg_tat_hours",
    text: "Avg TAT",
    formatter: (value) => `${parseFloat(value).toFixed(1)}h`,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "volume",
    text: "Volume",
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "reopen_rate",
    text: "Reopen %",
    formatter: (value) => `${parseFloat(value).toFixed(1)}%`,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "performance",
    text: "Performance",
    formatter: (value) => (
      <span
        className={`performance-badge ${
          value === "EXCELLENT"
            ? "excellent"
            : value === "GOOD"
            ? "good"
            : "needs-improvement"
        }`}
      >
        {value}
      </span>
    ),
    headerAlign: "center",
    align: "center",
  },
];

export const trackerAnalyticsColumns = [
  {
    dataField: "ticket_no",
    text: "Ticket ID",
    formatter: (value) => <span className="ticket-id">{value}</span>,
  },
  {
    dataField: "gym_name",
    text: "Gym Name",
    formatter: (value) => value.replace("WTF: ", ""),
  },
  {
    dataField: "category_name",
    text: "Category",
    formatter: (value) => (
      <span className="category-badge" style={{ fontSize: "12px" }}>
        {value}
      </span>
    ),
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "vendor_name",
    text: "Vendor",
    formatter: (_, row) =>
      row.payee_type === "self" ? (
        <span
          className="vendor-self"
          style={{
            fontSize: "12px",
          }}
        >
          Self
        </span>
      ) : (
        row.vendor_name || "N/A"
      ),
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "requested_amount",
    text: "Amount",
    formatter: (value) => `₹${value}`,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "payment_method",
    text: "Payment",
    formatter: (value) => (
      <span className="payment-method" style={{ fontSize: "12px" }}>
        {value?.toUpperCase()}
      </span>
    ),
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "invoice_img",
    text: "Invoice",
    formatter: (value) =>
      value ? (
        <Button
          variant="link"
          size="sm"
          onClick={() => window.open(value, "_blank")}
        >
          📄 View
        </Button>
      ) : (
        "N/A"
      ),
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "supervisor_name",
    text: "Supervisor",
    formatter: (value, row) => (
      <div>
        <div className="supervisor-name">{value}</div>
        <small className="supervisor-mobile">{row.supervisor_mobile}</small>
      </div>
    ),
  },
  {
    dataField: "ticket_created_date",
    text: "Date",
    formatter: (value) => new Date(value).toLocaleDateString(),
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "expense_status",
    text: "Status",
    formatter: (value) => (
      <span
        className={`ticket-system-status-badge status-${value.toLowerCase()}`}
      >
        {value.toUpperCase()}
      </span>
    ),
    headerAlign: "center",
    align: "center",
  },
];
